import { apiNhg } from "../../api/api";


export interface IAttestationFilters {
  UserId?: number;
  InstanciaId?: number;
  EntidadeId?: number;
  EntidadeOperacionalId?: number;
  Status?: number;
  DataEntregaDe?: string;
  DataEntregaAte?: string;
  DataIniDe?: string;
  DataFimAte?: string;
  AfastamentoTipoId?: number;
  AfastamentoSubTipoId?: number;
  GestorCpf?: string;
}

export class GestorService {
  static async getAttestations(filters: IAttestationFilters) {
    const response = await apiNhg.get('/Atestado/GetByFilter', {
      params: filters
    });
    return response.data;
  }
}
